import { useEffect, useRef } from 'react';
import { useAppSelector } from '../redux/helper';

/**
 * Runs `refresh` after an expense is deleted, never on mount. For screens that
 * show expense totals, stay mounted behind Expense Details and don't load on
 * focus. A locationVersion bump would also reach them, but it reloads every
 * back-office screen for one deleted row.
 */
const useRefreshAfterExpenseDelete = (refresh: () => unknown) => {
  const version = useAppSelector(s => s.backofficeExpenses?.version ?? 0);
  const seenVersionRef = useRef(version);
  const refreshRef = useRef(refresh);

  useEffect(() => {
    refreshRef.current = refresh;
  });

  useEffect(() => {
    if (seenVersionRef.current === version) return;
    seenVersionRef.current = version;
    void refreshRef.current();
  }, [version]);
};

export default useRefreshAfterExpenseDelete;
